import axiosHttp from "./interceptor";
import { emitToasterMsg } from "./toasterUtility";

export const getUKETSAERList = async (payload) => {
	try {
		const response = await axiosHttp.post("/api/UkEtsCompanyReport/GetUkEtsCompanyReportGrid", payload);

		const result = response?.data;

		return {
			Data: result?.data || [],
			Pagination: {
				TotalItems: result?.pagination?.totalItems || 0,
			},
		};
	} catch (error) {
		console.error("Error fetching UK ETS AER list:", error);

		emitToasterMsg("error", "Error", error?.response?.data?.errorMessage || error?.message || "Unable to fetch UK ETS Annual Emission Reports.");

		return {
			Data: [],
			Pagination: {
				TotalItems: 0,
			},
		};
	}
};

export const createUKETSAER = async (payload) => {
	try {
		const response = await axiosHttp.post("api/UkEtsCompanyReport/CreateUkEtsCompanyReport", payload);

		const data = response?.data;

		if (data?.ukEtsCompanyLevelReportId) {
			return {
				...data,
				isSuccess: true,
			};
		}
		return data;
	} catch (error) {
		const errorResponse = error?.response?.data;

		return {
			isSuccess: false,
			errorMessage: errorResponse?.errorMessage || errorResponse?.message || error?.message || "Unable to create the UK ETS Annual Emission Report.",
		};
	}
};

export const getUKETSAERDetails = async (ukEtsCompanyLevelReportId) => {
	try {
		const response = await axiosHttp.get(`api/UkEtsCompanyReport/GetUkEtsCompanyDetailsById?ukEtsCompanyLevelReportId=${ukEtsCompanyLevelReportId}`);

		return response?.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error?.response?.data?.message || error?.message || "Failed to load UK ETS company report details.");

		return null;
	}
};

export const updateUKETSCompanyName = async (payload) => {
	try {
		const response = await axiosHttp.post("api/UkEtsCompanyReport/UpdateUkEtsCompanyDetails", payload);
		return response?.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return { isSuccess: false };
	}
};

export const getUKETSAllShips = async (ukEtsAerMstId, payload) => {
	try {
		const response = await axiosHttp.post(`api/UkEtsCompanyReport/GetListOfShipsEligibleShips?ukEtsCompanyLevelReportId=${ukEtsAerMstId}`, payload);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return [];
	}
};

export const getUKETSAllEligibleShipIds = async (ukEtsAerMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/UkEtsCompanyReport/GetAllEligibleShipIds?ukEtsCompanyLevelReportId=${ukEtsAerMstId}`
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return [];
	}
};

export const getShipLevelReportSummary = async (ukEtsCompanyLevelReportId, reportMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/UkEtsCompanyReport/shiplevel-reportsummary?ukEtsCompanyLevelReportId=${ukEtsCompanyLevelReportId}&reportMstId=${reportMstId}`
		);

		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return null;
	}
};

export const saveUKETSOverrideValues = async (payload) => {
	try {
		const response = await axiosHttp.post("api/UkEtsCompanyReport/SaveUseOverrideValues", payload);

		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		throw error;
	}
};

export const getUKETSReportSummary = async (ukEtsAerMstId) => {
	try {
		const response = await axiosHttp.get(`api/UkEtsCompanyReport/GetUkEtsCompanyReportSummary?ukEtsCompanyLevelReportId=${ukEtsAerMstId}`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return [];
	}
};

export const getUKETSAssociatedDocuments = async (ukEtsCompanyLevelReportId, isVerificationDocument) => {
	try {
		const response = await axiosHttp.get(
			`api/UkEtsCompanyReport/GetUkEtsCompanyReportDocumentsById?ukEtsCompanyLevelReportId=${ukEtsCompanyLevelReportId}&isVerificationDocument=${isVerificationDocument}`
		);

		return response;
	} catch (error) {
		console.error("Error fetching UK ETS associated documents:", error);

		return {
			isSuccess: false,
			errorMessage: error?.response?.data?.errorMessage || error?.message || "Unable to load associated documents.",
		};
	}
};

export const uploadUKETSDocument = async (formData) => {
	try {
		const response = await axiosHttp.post("api/UKEtsAer/UploadDocument", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Upload Failed", error.message);
		return { isSuccess: false };
	}
};

export const downloadUKETSDocument = async (documentMstId) => {
	try {
		const response = await axiosHttp.get(`api/UKEtsAer/DownloadDocument?documentMstId=${documentMstId}`, { responseType: "blob" });
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Download Failed", error.message);
		return null;
	}
};

export const saveUKETSAerReports = async (uketsAerMstId, aerReportIds, isReportSummaryTab) => {
	try {
		const response = await axiosHttp.post(
			`/api/UkEtsCompanyReport/SubmitUkEtsReport?ukEtsCompanyReport=${uketsAerMstId}&isReportSummaryTab=${isReportSummaryTab}`,
			aerReportIds
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Submit Failed", error.message);
		return { isSuccess: false };
	}
};

export const sendUKETSAerToCompany = async (uketsAerMstId, remarks) => {
	try {
		const response = await axiosHttp.post(`api/UkEtsCompanyReport/submit-to-company?ukEtsCompanyReport=${uketsAerMstId}&rejectedRemarks=${remarks}`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return { isSuccess: false };
	}
};

export const assignUKETSAER = async (uketsReportId, userEmail) => {
	try {
		const response = await axiosHttp.post(`api/UkEtsCompanyReport/assign-reviewer?ukEtsCompanyLevelReportId=${uketsReportId}&userEmail=${userEmail}`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return { isSuccess: false };
	}
};

export const claimUKETSAER = async (uketsReportId) => {
	try {
		const response = await axiosHttp.post(`api/UkEtsCompanyReport/Claim-Report?ukEtsCompanyLevelReportId=${uketsReportId}`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return { isSuccess: false };
	}
};

export const unclaimUKETSAER = async (uketsReportId) => {
	try {
		const response = await axiosHttp.post(`api/UkEtsCompanyReport/UnClaim-Report?ukEtsCompanyLevelReportId=${uketsReportId}`);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
		return { isSuccess: false };
	}
};

export const downloadUKETSAERDeliverable = async (ukEtsAerMstId) => {
	try {
		const response = await axiosHttp.get(`api/UkEtsCompanyReport/DownloadAllUkEtsVerificationDocumentsById?ukEtsCompanyLevelReportId=${ukEtsAerMstId}`, {
			responseType: "blob",
		});
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Download Failed", error.message);
		return null;
	}
};

export const deleteUKETSAER = async (ukEtsAerId) => {
	try {
		const response = await axiosHttp.post(`api/UkEtsCompanyReport/DeleteUkEtsCompanyReport?ukEtsCompanyLevelReportId=${ukEtsAerId}`);

		return response?.data;
	} catch (error) {
		console.error("Error deleting UK ETS AER:", error);

		return {
			isSuccess: false,
			errorMessage: error?.response?.data?.errorMessage || error?.message || "Unable to delete the UK ETS report.",
		};
	}
};
